module.exports = __webpack_public_path__ + "static/media/bullhorn-solid.b1067e44.svg";